export * from '@core/js/hooks/user/helpers';

export const addCaptainUpScript = () => {
    const script = document.createElement('script');
    script.src = 'https://captainup.com/assets/sdk.js';
    script.async = true;
    document.head.appendChild(script);
    return new Promise((resolve) => {
        script.onload = resolve;
    });

};

